import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSquareBehindSquare1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3.75C2 2.7835 2.7835 2 3.75 2H14.25C15.2165 2 16 2.7835 16 3.75V8H20.25C21.2165 8 22 8.7835 22 9.75V20.25C22 21.2165 21.2165 22 20.25 22H9.75C8.7835 22 8 21.2165 8 20.25V16H3.75C2.7835 16 2 15.2165 2 14.25V3.75ZM15 8H9.75C8.7835 8 8 8.7835 8 9.75V15H3.75C3.33579 15 3 14.6642 3 14.25V3.75C3 3.33579 3.33579 3 3.75 3H14.25C14.6642 3 15 3.33579 15 3.75V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
